// extracted by mini-css-extract-plugin
export default {"hiddenContent":"hiddenContent---Qxr4Z"};